module.exports = __webpack_public_path__ + "3bf00960d1f46ecb04d9c0660b12e3e8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-12.png
// module id = 2623
// module chunks = 0